module.exports = __webpack_public_path__ + "static/1@2x-9f5abd13cf09ec7bb5407732a39b31ee.png";